<template>
  <el-time-picker
    is-range
    v-model="selectValue"
    @change="changeHanlder"
    :format="format"
    :value-format="valueFormat"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    editable
    clearable
    :style="{ width: width }"
  >
  </el-time-picker>
</template>

<script>
export default {
  name: "QsWebTimeRangePicker",
  props: {
    minVal: [Number, String],
    maxVal: [Number, String],
    width: {
      type: [String, Number],
      required: false,
      default() {
        return "500px";
      },
    },
    format: {
      type: String,
      default: "HH:mm:ss",
    },
    valueFormat: {
      type: String,
      default: "HH:mm:ss",
    },
  },
  watch: {
    minVal: {
      handler(val) {
        if (this.minVal && this.maxVal) {
          this.selectValue = [this.minVal, this.maxVal];
        }
      },
      immediate: true,
    },
    maxVal: {
      handler(val) {
        if (this.minVal && this.maxVal) {
          this.selectValue = [this.minVal, this.maxVal];
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      selectValue: null,
    };
  },

  mounted() {},

  methods: {
    changeHanlder(val) {
      this.$emit("update:minVal", val && val[0] ? val[0] : null);
      this.$emit("update:maxVal", val && val[1] ? val[1] : null);
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/qs/TimeRangePicker.vue